export default "__VITE_ASSET__QCf4c1kG__"